import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

const SidebarContent = ({ onClick, changeToLight, changeToDark }) => {
  const hideSidebar = () => {
    onClick();
  };

  const [userPermits, setUserPermits] = useState([]);
  const id_clinic = JSON.parse(sessionStorage.getItem('clinica'))
  useEffect(() => {
    let user = JSON.parse(sessionStorage.getItem('usuario'));

    if (user != null) {
      if (user.perfil != undefined) {
        let perfil = user.perfil.modulos;
        setUserPermits(perfil);
      } else {
        let perfil = [];
        setUserPermits(perfil);
      }
    } else {
    }
  }, [])

  return (
    <div className="sidebar__content">
      <ul className="sidebar__block">
        {userPermits.includes(21) || userPermits.includes(22) || userPermits.includes(37) ?
          <SidebarCategory title="Administrativo" icon="apartment">
            {/* <SidebarLink title="Nomina" route="/" onClick={hideSidebar} />
            <SidebarLink title="Activos" route="/" onClick={hideSidebar} /> */}
            {/* <SidebarLink title="Carteras" route="/" onClick={hideSidebar} /> */}
            <SidebarCategory title="Cartera">
              <SidebarLink title="Pagos" route={`${process.env.PUBLIC_URL}/management/payments`} onClick={hideSidebar} />
              <SidebarLink title="Retenciones" route={`${process.env.PUBLIC_URL}/management/retentions`} onClick={hideSidebar} />
              <SidebarLink title="Cartera" route={`${process.env.PUBLIC_URL}/management/billfold`} onClick={hideSidebar} />
              <SidebarLink title="Anticipos" route={`${process.env.PUBLIC_URL}/management/advanced-payment`} onClick={hideSidebar} />
            </SidebarCategory>
            {/*  <SidebarLink title="Compras" route="/" onClick={hideSidebar} />
            <SidebarLink title="Cuentas" route="/" onClick={hideSidebar} />
            <SidebarLink title="Glosas" route="/" onClick={hideSidebar} />
            <SidebarLink title="Tesoreria" route="/" onClick={hideSidebar} /> */}
            {userPermits.includes(21) ?
              <SidebarLink title="Cotizador" route={`${process.env.PUBLIC_URL}/billing/quotes`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(21) ?
              <SidebarLink title="Estudios Clinicos" route={`${process.env.PUBLIC_URL}/clinical-studio/search`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(22) ?
              <SidebarLink title="Honorarios" route={`${process.env.PUBLIC_URL}/fees`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(37) ?
              <SidebarLink title="Inventario" route={`${process.env.PUBLIC_URL}/inventory`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(38) && userPermits.includes(16) ?
              <SidebarLink title="Facturador" route={`${process.env.PUBLIC_URL}/manual-invoice`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(38) && userPermits.includes(16) ?
              <SidebarLink title="Gastos" route={`${process.env.PUBLIC_URL}/expenses`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(20) ?
              <SidebarLink title="Cuentas Contables" route={`${process.env.PUBLIC_URL}/management/accounting-accounts`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(20) ?
              <SidebarLink title="Reporte de Cuentas Contables" route={`${process.env.PUBLIC_URL}/management/accounting-accounts-reports`} onClick={hideSidebar} />
              : null}
          </SidebarCategory>
          : null}
        {userPermits.includes(1) || userPermits.includes(4) || userPermits.includes(5) || userPermits.includes(6)
          || userPermits.includes(7) || userPermits.includes(8) || userPermits.includes(10) || userPermits.includes(12)
          || userPermits.includes(13) || userPermits.includes(17) || userPermits.includes(18) || userPermits.includes(23)
          || userPermits.includes(24) || userPermits.includes(29) || userPermits.includes(35) ?
          <SidebarCategory title="Configuración" icon="cog">
            {userPermits.includes(35) ?
              <SidebarLink title="Generacion de Agenda" route={`${process.env.PUBLIC_URL}/config/agenda`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(1) ?
              <SidebarLink title="Generacion de Agenda" route={`${process.env.PUBLIC_URL}/config/make-schedule`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(5) ?
              <SidebarLink title="Terceros" route={`${process.env.PUBLIC_URL}/config/terceros/listar`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(4) ?
              <SidebarLink title="Servicios" route={`${process.env.PUBLIC_URL}/config/services`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(4) ?
              <SidebarLink title="Medicamentos" route={`${process.env.PUBLIC_URL}/config/medicines`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(4) ?
              <SidebarLink title="Habitaciones" route={`${process.env.PUBLIC_URL}/config/rooms`} onClick={hideSidebar} />
              : null}  
            {userPermits.includes(29) ?
              <SidebarLink title="Accesos Rapidos de Servicios" route={`${process.env.PUBLIC_URL}/config/quick-access-services`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(8) ?
              <SidebarLink title="Profesionales" route={`${process.env.PUBLIC_URL}/config/professional-list`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(12) ?
              <SidebarLink title="Perfiles" route={`${process.env.PUBLIC_URL}/config/manage-profile`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(13) ?
              <SidebarLink title="Usuarios" route={`${process.env.PUBLIC_URL}/config/manage-users`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(17) ?
              <SidebarLink title="Parametrización" route={`${process.env.PUBLIC_URL}/config/profile`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(17) ?
              <SidebarLink title="Configuración de Salas de Espera" route={`${process.env.PUBLIC_URL}/config/living-room`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(17) ?
              <SidebarLink title="Espacios" route={`${process.env.PUBLIC_URL}/config/workspaces`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(18) ?
              <SidebarLink title="Factura Electronica" route={`${process.env.PUBLIC_URL}/config/invoice`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(23) ?
              <SidebarLink title="Plantillas" route={`${process.env.PUBLIC_URL}/config/editemplates`} onClick={hideSidebar} />
              : null}
          </SidebarCategory>
          : null}

        {userPermits.includes(3) || userPermits.includes(9) || userPermits.includes(11) || userPermits.includes(25) || userPermits.includes(28) || userPermits.includes(30) ||
          userPermits.includes(48) ||
          userPermits.includes(49) || userPermits.includes(50)
          ?
          <SidebarCategory title="Asistencial" icon="heart-pulse">
            {userPermits.includes(3) ?
              <SidebarLink title="Admisiones" route={`${process.env.PUBLIC_URL}/assitencial/admissions`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(9) ?
              <SidebarLink title="Listado de Pacientes" route={`${process.env.PUBLIC_URL}/assitencial/patient-list`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(11) || userPermits.includes(30) ?
              <SidebarLink title={
                userPermits.includes(11) ? "Historia Clinica" :
                  userPermits.includes(30) ? "Pacientes" : ""
              } route={`${process.env.PUBLIC_URL}/assitencial/search-clinic-history`} onClick={hideSidebar} />
              : null}

            {userPermits.includes(25) && id_clinic?.id_clinica === 1 ?
              <SidebarLink title="Análisis de CIOM y SUSAR" route={`${process.env.PUBLIC_URL}/assitencial/eventadverse`} onClick={hideSidebar} />
              : null}
            {/* {userPermits.includes(28) ?
              <SidebarLink title="Imagenologia" route="/" onClick={hideSidebar} />
              : null} */}

            {userPermits.includes(28) ?
              <SidebarLink title="Sala de Espera Pacientes" route={`${process.env.PUBLIC_URL}/patients-call?id_clinica=${sessionStorage.getItem('id_clinca')}&token=${sessionStorage.getItem('token')}`} onClick={hideSidebar} />
              : null}

            {/**Esteban Londoño Ospina 06/09/2021 -> Se coloca en Asistencial mientras tanto */}
            {userPermits.includes(28) ?
              <SidebarLink title="Radio Farmacia" route={`/radio-pharmacy/list`} onClick={hideSidebar} />
              : null}

            {userPermits.includes(48) ?
              <SidebarLink title="Quejas y Reclamos" route={`${process.env.PUBLIC_URL}/assitencial/complaints-claims`} onClick={hideSidebar} />
              : null}

            {userPermits.includes(49) || userPermits.includes(50) ?
              <SidebarLink title="Encuesta al Paciente" route={`${process.env.PUBLIC_URL}/assitencial/survey-patients`} onClick={hideSidebar} />
              : null}

            {/* {userPermits.includes(28) ?
              <SidebarLink title="Laboratorio Clínico" route="/" onClick={hideSidebar} />
              : null}
            {userPermits.includes(28) ?
              <SidebarLink title="Comité de Ética" route="/" onClick={hideSidebar} />
              : null}
            {userPermits.includes(28) ?
              <SidebarLink title="Desviaciones" route="/" onClick={hideSidebar} />
              : null} */}
          </SidebarCategory>
          : null}


        {userPermits.includes(2) || userPermits.includes(16) || userPermits.includes(14) || userPermits.includes(15) || userPermits.includes(20) || userPermits.includes(54) ?
          <SidebarCategory title="Apoyo a la Gestion" icon="list">
            {userPermits.includes(2) ?
              <SidebarLink title="Asignación de la Agenda" route={`${process.env.PUBLIC_URL}/management/schedule`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(16) ?
              <SidebarLink title="Documentos Clientes" route={`${process.env.PUBLIC_URL}/management/search-invoice-costumer`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(20) ?
              <SidebarLink title="Recibos de Caja" route={`${process.env.PUBLIC_URL}/management/search-receipts`} onClick={hideSidebar} />
              : null}
              {userPermits.includes(54) ?
              <SidebarLink title="Estado de Facturación Pacientes" route={`${process.env.PUBLIC_URL}/management/patients-pending-invoice`} onClick={hideSidebar} />
              : null}
          </SidebarCategory>
          : null}

        {userPermits.includes(12) || userPermits.includes(26) || userPermits.includes(27) || userPermits.includes(52) || userPermits.includes(55)
          || userPermits.includes(15) ?
          <SidebarCategory title="Estrategicos" icon="book">
            {userPermits.includes(12) ?
              <SidebarLink title="Informes" route="/" onClick={hideSidebar} />
              : null}
            {userPermits.includes(26) ?
              <SidebarLink title="Indicadores" route={`${process.env.PUBLIC_URL}/strategic/indicators`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(26) ?
              <SidebarLink title="Indicadores de Calidad" route={`${process.env.PUBLIC_URL}/strategic/quality-indicators`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(27) ?
              <SidebarLink title="Reportes" route={`${process.env.PUBLIC_URL}/strategic/reports`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(27) ?
              <SidebarLink title="Reportes de Pacientes" route={`${process.env.PUBLIC_URL}/strategic/report-patients`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(12) ?
              <SidebarLink title="Comites" route="/" onClick={hideSidebar} />
              : null}
            {userPermits.includes(27) || userPermits.includes(55) ?
              <SidebarLink title="RIPS" route={`${process.env.PUBLIC_URL}/strategic/rips`} onClick={hideSidebar} />
              : null}
            {userPermits.includes(52) ?
              <SidebarLink title="Business Intelligent" route={`${process.env.PUBLIC_URL}/strategic/business-intelligence`} onClick={hideSidebar} />
              : null}
          </SidebarCategory>
          : null}
      </ul>
    </div>
  );
};

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SidebarContent;
